export default {
  oma: {
    filterByDate: "Filtrar por data",
    fromDate: "Data Inicial",
    toDate: "Data Final",
    selectDate: "Selecionar Data",
    cancel: "CANCELAR",
    avocadoTreesList: "Lista de Árvores de Abacate",
    addTreesManually: "Adicionar Localização Geo de Árvores Manualmente",
    confirmationTitle: "Confirmação",
    confirmationMessage: "Árvore de Abacate foi adicionada/editada com sucesso",
    addTreesBulk: "Importar árvores em massa",
    addNewFarm: "Selecionar Fazenda",
    selectFarm: "Selecionar Fazenda",
    selectZone: "Selecionar Zona",
    treeId: "ID da Árvore",
    treeName: "Nome da Árvore",
    zoneId: "ID da Zona",
    latitude: "Latitude",
    longitude: "Longitude",
    altitude: "Altitude",
    timestamp: "timestamp",
    avocadoTrees: "Árvores de Abacate",
    avocadoDetailNoUpdates: "Sem Atualizações",
    avocadoTreeDetail: "Detalhes da Árvore",
    avocadoTreeDetailHeader: "Detalhes da Árvore de Abacate",
    avocadoTreeUpdates: "Atualizações da Árvore de Abacate",
    avocadoAddImages: "Adicionar Novas Imagens",
    addNewTreeImage: "Adicionar Novas Imagens da Árvore",
    selectCountry: "Selecionar País",
    allRegions: "Todas as Regiões",
    cropsReport: "Relatório de Culturas",
  today: "Hoje",
  week: "Semana",
  month: "Mês",
  year: "Ano",
  all: "Tudo",
  cropsStatistics: "Estatísticas de Culturas",
  crops: "Culturas",
  acres: "Acres",
  totalPlantedArea: "Área Total Plantada",
  farmersChart: "Gráfico de Agricultores",
  cropsName: "Nome das Culturas",
  farmers: "Agricultores",
  farms: "Fazendas",
  planted: "Plantado",
  plantedArea: "Área Plantada",
  harvested: "Colhido",
  yieldAcre: "Rendimento/Acre",
  selectCrop: "Selecionar Cultura",
  listByYield: "Listar por Rendimento",
  listByPlantedArea: "Listar por Área Plantada",
  equipmentReport: "Relatório de Equipamentos",
  equipmentChart: "Gráfico de Equipamentos",
  selectFarmer: "Selecionar Agricultor",
  selectFarmers: "Selecionar Agricultores",
  equipmentName: "Nome do Equipamento",
  region: "Região",
  counts: "Contagens",
  large: "Grande",
  medium: "Médio",
  small: "Pequeno",
  listByFarmer: "Listar por Agricultor",
  rowsPerPage: "Linhas por página",
  farmersReport: "Relatório de Agricultores",
  farmsReport: "Relatório de Fazendas",
  farmersStatistics: "Estatísticas de Agricultores",
  farmStatistics: "Estatísticas de Fazendas",
  averageFarmerLand: "Terreno Médio por Agricultor",
  largeFarmers: "Grandes Agricultores",
  mediumFarmers: "Agricultores Médios",
  smallFarmers: "Pequenos Agricultores",
  listByLand: "Listar por Terreno",
  listByFarm: "Listar por Fazenda",
  AvgLandAcre: "Terreno Médio/Acre",
  listbyCrop: "Listar por Cultura",
  listbyZone: "Listar por Zona",
  farmName: "Nome da Fazenda",
  zones: "Zonas",
  area: "Área",
  goalsAchievedReport: "Relatório de Metas Alcançadas",
  listByCrops: "Listar por Culturas",
  goalsAchievedChart: "Gráfico de Metas Alcançadas",
  goalsAchieved: "Metas Alcançadas",
  goalsFailed: "Metas Falhadas",
  successRate: "Taxa de Sucesso",
  achieved: "Alcançado",
  equipment: "Equipamento",
  pests: "Pragas",
  regions: "Regiões",
  filterByCrops: "Filtrar por Culturas",
  searchCrops: "Pesquisar Culturas",
  batchCode: "Código do Lote",
  batchRating: "Avaliação do Lote",
  MakeASelection: "Faça uma seleção",
  typeTotalCoffeeQuantity: "Digite a quantidade total de café",
  typeHumidity: "Digite a umidade",
  valueInPercent: "valor em %",
  purchaseOrderRequired: "Pedido de Compra é obrigatório",
  totalCoffeeCherryRequired:
    "Quantidade total de cerejas de café é obrigatória",
  processTypeRequired: "Tipo de Processo é obrigatório",
  fermentationTypeRequired: "Tipo de Fermentação é obrigatório",
  stationInfo: "Informações da Estação",
  purchaseOrders: "Pedidos de Compra",
  processingBatch: "Processamento de Lote",
  processedCoffeeOutRequired: "Saída de Café Processado é obrigatória",
  lotNo: "Número do Lote",
  addNewS: "Adicionar Novo",
  viewAll: "Ver Todos",
  parchmentOut: "Parchment Out",
  processingDone: "Processamento Concluído",
  farmerLotID: "ID do Agricultor e Lote",
  weight: "Peso",
  plantationSettings: "Configurações da Plantação",
  PlantationsEachFarmerCanCreate:
    "Número de Plantações que Cada Agricultor Pode Criar",
  manageAdditionalPlantationRequests:
    "Gerenciar Solicitações Adicionais de Plantação",
  autoApprove: "Aprovação Automática",
  adminApprovalRequired: "Aprovação do Administrador Obrigatória",
  close: "Fechar",
  new_user: "Novo Usuário",
  KGAcre: "KG/Acre",

  // Sept 29, 2030
  honey: "Mel",
  naturalDry: "Natural (Seco)",
  wine: "Vinho",
  SemiWashed: "Semi-Lavado",
  fullWashed: "Totalmente Lavado",
  startDateRequired: "Data de Início é obrigatória",
  endDateRequired: "Data de Término é obrigatória",
  assigned: "Atribuído",
  activated: "Ativado",
  unassigned: "Não Atribuído",
  deleteTopic: "Excluir Tópico",
  sureToDeleteTopic:
    "Tem certeza de que deseja excluir o tópico de problemas técnicos?",
  publishSurvey: "Publicar Pesquisa",
  endSurvey: "Encerrar Pesquisa",
  copy: "Copiar",
  pending: "Pendente",

  //Dashboad Report Translation
  "Farmer Name": "Nome do Agricultor",
  "Goals Achieved": "Metas Alcançadas",
  "Goals Failed": "Metas Falhadas",
  "Success Rate": "Taxa de Sucesso",
  "Farm Size": "Tamanho da Fazenda",
  "Small Farmer": "Pequeno Agricultor",
  "Medium Farmer": "Agricultor Médio",
  "Large Farmer": "Grande Agricultor",
  
    //land suitability
    landSuitibility: "Adequação do terreno",
    landSuitibilityReport: "Relatório de Adequação do Terreno",
    generateNewReport: "Gerar novo relatório",
    operatorName: "Nome do operador",
    issueDate: "Data de emissão",
    chooseYourLocation: "Escolha sua localização",
    getLandEvaluation: "Obter avaliação do terreno",
    downloadPdfReport: "Baixar relatório em PDF",
    pleaseEnterCoordinateText: "Por favor, insira as coordenadas (latitude e longitude) da localização da fazenda para ver a pontuação.",
    noRecordAvailable: "Nenhum registro disponível.",
    overallScoreForLand: "Pontuação geral para a adequação do terreno",
    landEvaluation: "Avaliação do terreno",
    unsuitable: "Inadequado",
    marginally: "Marginalmente",
    suitable: "Adequado",
    moderately: "Moderadamente",
    highly: "Altamente",
    back: "Voltar",
    search: "Pesquisar",
    showResults: "Mostrar resultados",

    //analysis report
    weatherAnalysisReport: "Relatórios de Análise do Clima",
    weatherAnalysis: "Análise do Clima",
    getWeatherAnalysis: "Obter análise do clima",
    weatherReport: "Relatório do Clima",
    insertCoordinateText:
      "Insira as coordenadas da fazenda (ou árvore) acima ou use o mapa abaixo para indicar a localização da fazenda (ou árvore).",
    addTreeGeolocation: "Adicionar geolocalização da árvore",
    editTreeGeolocation: "Editar geolocalização da árvore",
    plantationDate: "Data de plantio",
    notes: "Notas",
    uploadTreeImages: "Carregar imagens da árvore",

    valueAtTheCoordinatesOfInterest: "Valor na Coordenada de Interesse",
    "Slope (%)": "Inclinação (%)",
    "Soil texture (USDA class)": "Textura do solo (classe USDA)",
    "Coarse fragments (vol%)": "Fragmentos grossos (vol%)",
    Land: "Terra",
    "Artificial surfaces (type)": "Superfícies artificiais (tipo)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "Proximidade às Estradas Tipo 1 e 2 (metros)",
    "Soil Chemical Properties": "Propriedades químicas do solo",
    "Soil Physical Properties": "Propriedades físicas do solo",
    "Soil organic carbon (%)": "Carbono orgânico do solo (%)",
    "Soil pH": "pH do solo",
    "Soil salinity (ECe))": "Salinidade do solo (ECe)",
    "Mean annual temperature (°C)": "Temperatura média anual (°C)",
    Weather: "Tempo",
    "Mean minimum temperature of coldest month (°C)":
      "Temperatura mínima média do mês mais frio (°C)",
    "Mean annual precipitation (mm)": "Precipitação anual média (mm)",

    avocadoDetailCard: {
      clientTreeId: "ID da Árvore",
      treeName: "Nome da Árvore",
      latitude: "Latitude",
      longitude: "Longitude",
      altitude: "Altitude",
      zoneId: "ID da Zona",
      createdAt: "Data e Hora de Criação",
      plantationDate: "Data e Hora de Plantio",
      updatedAt: "Última Atualização",
    },
    importCSVFormat: "Importar Formato CSV",
    importGeoJsonFormat: "Importar Formato GeoJSON",
    importShapeFilesFormat: "Importar Formato Shape Files",
    importXLSFormat: "Importar Formato XLS",
    importGeobufFormat: "Importar Formato Geobuf",
    importGeoPackageFormat: "Importar Formato GeoPackage",
    importTopoJsonFormat: "Importar Formato TopoJSON",

    avocadoTreeDetailsTableHeader: {
      updatedOn: "Atualizado Em",
      updatedBy: "Atualizado Por",
      notes: "Notas",
      noOfImages: "Nº de Imagens",
      actions: "Ação",
    },
    avocadoTreeView: "Visualização da Árvore",
    avocadoFarmView: "Visualização da Fazenda",
    avocadoTreeDetailPopupTitle: "Visualizar Detalhes da Árvore",
    dateOfInterest: "Data de Interesse",
    maximumCloudCoverage: "Cobertura Máxima de Nuvens",

    import: "Importar",
    history: "Histórico",
    downloandimport: "Baixar e Importar",
    importantNote: "Nota Importante",
    downloadXlsFormat: "Baixar Formato XLS",
    downloadCSVFormat: "Baixar Formato CSV",
    downloadGeoJSONFormat: "Baixar Formato GeoJSON",
    downloadTopoJSONFormat: "Baixar Formato TopoJSON",
    downloadGeoPackageFormat: "Baixar Formato GeoPackage",
    downloadGeobufFormat: "Baixar Formato Geobuf",

    selectXLSFile: "Selecionar Arquivo XLS",
    selectCSVFile: "Selecionar Arquivo CSV",
    selectGeoJSONFile: "Selecionar Arquivo GeoJSON",
    selectTopoJSONFile: "Selecionar Arquivo TopoJSON",
    selectGeoPackageFile: "Selecionar Arquivo GeoPackage",
    selectGeobufFile: "Selecionar Arquivo Geobuf",
    OrDragDrop: "ou arraste e solte aqui",
    importTrees: "Importar Árvores",
    importantNoteDetail:
      "Por favor, utilize os modelos fornecidos acima para uploads em massa.\n" +
      "Outros formatos resultarão em falha.",

    fileName: "Nome do Arquivo",
    importedOn: "Importado Em",
    status: "Status",
    actions: "Ação",
    action: "Ação",
    download: "Baixar",
    removeFile: "Remover Arquivo",
    importedTrees: "Árvores Importadas",
    geolocation: "Geolocalização",

    "Export CSV Format": "Exportar Formato CSV",
    "Export XLSX Format": "Exportar Formato XLSX",
    "Export PDF Format": "Exportar Formato PDF",
    noHistoryFound: "Nenhum Histórico Encontrado",
  },
}